export const UNEXPECTED_ERROR = 'Unexpected error occurred!'
export const TOO_MUCH_RESEND =
  'Too much resend email requests in last 5 minutes'
export const USER_MUST_HAVE_PASSWORD =
  'User must have password to do this action'
export const PASSWORD_CANNOT_BE_THE_SAME =
  'Password cannot be same as was before'
export const USER_WITH_THAT_EMAIL_EXISTS = 'User with that email already exists'
